import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import DonationContext from "../../../context/donation/context";
import DonationContextProvider from "../../../context/donation/provider";
import PageDetails from "../../general/details";
import Spin from "../../general/antd/spin";
import Descriptions from "../../general/antd/descriptions";
import { Descriptions as AntdDescriptions } from "antd";
import AppContext from "../../../context/app/context";
import { getDonationStatus, getDonationTarget } from "../../../models/donation/enum";

interface Props {}

const DonationDetails: React.FC<Props> = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const { details, actions, loading } = useContext(DonationContext);
    const { direction } = useContext(AppContext);

    useEffect(() => {
        const getDetails = async () => {
            id && (await actions.getDetails(Number(id)));
        };
        getDetails();
    }, [direction]);

    return (
        <PageDetails
            title={t("details")}
            subtitle={t("donations_manager")}
        >
            {loading.includes("details") ? (
                <Spin />
            ) : (
                <Descriptions size="small" column={1} bordered>
                    <AntdDescriptions.Item label={t("id")}>
                        {details?.id}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("donor_name")}>
                        {`${details?.donor?.firstName ?? ""} ${details?.donor?.lastName ?? ""}`}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("donor_mobile")}>
                        {details?.donor?.mobile ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("target")}>
                            {getDonationTarget(details?.target)}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("target_id")}>
                        {details?.targetId}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("target_name")}>
                        {details?.targetModel && "name" in details.targetModel
                            ? details.targetModel.name
                            : details?.targetModel && "firstName" in details.targetModel
                            ? `${details.targetModel.firstName} ${details.targetModel.lastName}`
                            : "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("period_ratio")}>
                        {details?.periodRatio ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("donation_unit")}>
                        {details?.donationUnit ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("total_donation")}>
                        {details?.totalDonation ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("count")}>
                        {details?.count ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("currency")}>
                        {details?.currency ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("status")}>
                            {getDonationStatus(details?.status) ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("gift")}>
                        {details?.giftAble ? "🎁" : "❌"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("created_at")}>
                        {details?.createdAt ? new Date(details.createdAt).toLocaleDateString() : "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("payment_id")}>
                        {details?.payment?.id ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("payment_created_at")}>
                        {details?.payment?.createdAt ? new Date(details.payment.createdAt).toLocaleDateString() : "-"}
                    </AntdDescriptions.Item>
                </Descriptions>
            )}
        </PageDetails>
    );
};

const DonationDetailsPage = () => {
    return (
        <DonationContextProvider>
            <DonationDetails />
        </DonationContextProvider>
    );
};

export default DonationDetailsPage;